function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 0C5.59667 0 0 5.59625 0 12.5C0 19.4037 5.59667 25 12.5 25C19.4033 25 25 19.4033 25 12.5C25 5.59625 19.4033 0 12.5 0ZM16.2304 17.7825C15.3767 18.5125 14.1708 18.8771 12.6121 18.8771C11.0204 18.8771 9.76792 18.5175 8.85625 17.7987C7.94417 17.0792 7.48833 16.0912 7.48833 14.8333H9.89958C9.97792 15.3858 10.1317 15.7983 10.36 16.0721C10.7792 16.57 11.4963 16.8183 12.5125 16.8183C13.1213 16.8183 13.615 16.7533 13.9946 16.6212C14.7154 16.3696 15.0754 15.9025 15.0754 15.2192C15.0754 14.8204 14.8987 14.5113 14.5462 14.2921C14.1929 14.0788 13.6333 13.89 12.8675 13.7267L11.5588 13.4396C10.2721 13.1546 9.38833 12.8462 8.9075 12.5129C8.09208 11.955 7.685 11.0829 7.685 9.89625C7.685 8.81333 8.08375 7.91417 8.88042 7.19792C9.67708 6.48125 10.8483 6.12333 12.3929 6.12333C13.6829 6.12333 14.7821 6.46083 15.6938 7.13625C16.6038 7.81167 17.0813 8.79208 17.1263 10.0771H14.6979C14.6533 9.35 14.3283 8.83333 13.7229 8.52667C13.3192 8.32458 12.8171 8.22292 12.2175 8.22292C11.55 8.22292 11.0179 8.35417 10.62 8.61667C10.2221 8.87917 10.0225 9.24542 10.0225 9.71583C10.0225 10.1479 10.2188 10.4704 10.6117 10.6833C10.8633 10.8258 11.3988 10.9925 12.2179 11.1838L14.3396 11.6842C15.2688 11.9025 15.9662 12.1954 16.4304 12.5612C17.1508 13.13 17.5113 13.9533 17.5113 15.03C17.5113 16.1346 17.085 17.0525 16.2304 17.7825Z",
  fill: "url(#paint1_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 0,
  y1: 12.5,
  x2: 25,
  y2: 12.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C5C7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.52,
  stopColor: "#DCDDDF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EBEBEB"
})));

function SvgSilver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilver);
export default __webpack_public_path__ + "static/media/silver.685ead0a.svg";
export { ForwardRef as ReactComponent };